import React from "react";

const ServerError = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "20px",
      }}
    >
      <img
        src="/server.svg"           // ✅ isko public/500.svg me rakhna
        alt="Server Error"
        style={{ width: "260px", marginBottom: "20px" }}
      />

      <h1 style={{ fontSize: "40px", marginBottom: "10px", color: "#d9534f" }}>
        500 - Server Error
      </h1>

      <p style={{ fontSize: "18px", color: "#777", maxWidth: "500px" }}>
        Something went wrong on our server. Please try again later.
      </p>

      <a
        href="/"
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          background: "#007bff",
          color: "#fff",
          borderRadius: "5px",
          textDecoration: "none",
        }}
      >
        Go to Home
      </a>
    </div>
  );
};

export default ServerError;
